import { EntityManagerFieldInfos } from '@record-it-npm/synchro-client';
import { createUserGroupToUserEntityInfo } from 'record-it-time-common/entity/entities/UserGroupToUser/createUserGroupToUserEntityInfo';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';
import { UserGroupToUser } from './userGroupToUserTypes';
export const userGroupToUserEntityInfo = createUserGroupToUserEntityInfo<UserGroupToUser>({
  additionalFieldInfos: EntityManagerFieldInfos.createAdditionalFieldInfos<AppSynchronizationEnvironmentTypes>()
});